import { render } from "./RemovableTag.vue?vue&type=template&id=15c0325b"
import script from "./RemovableTag.vue?vue&type=script&lang=js"
export * from "./RemovableTag.vue?vue&type=script&lang=js"
script.render = render

export default script